import axios from 'axios';
import requestInterceptors from '../../util/Common/API/requestInterceptors';
import responseInterceptors from '../../util/Common/API/responseInterceptors';

const ADMIN_DIV_CONF_BASE_URL = `${process.env.REACT_APP_BASE_URL}/div-manager/`;

/**
 * @description
 * Function that configure axios property
 * @param {string | any} withCredentials
 * Parameter to include credentials in the request
 * @param {string | any} xsrfHeaderName
 * Parameter to include xsrf header name
 * @param {string | any} xsrfCookieName
 * Parameter to include xsrf cookie name
 * @param {object} headers
 * Parameter to include headers
 * @returns {object}
 * Axios property
 */
const configureAxiosProperty = ({
  withCredentials,
  xsrfHeaderName,
  xsrfCookieName,
  headers,
}) => {
  return {
    withCredentials: withCredentials || true,
    xsrfHeaderName: xsrfHeaderName || 'X-CSRFTOKEN',
    xsrfCookieName: xsrfCookieName || 'XCSRF-TOKEN',
    headers: {
      ...headers,
    },
  };
};

/**
 * Axios object with base url
 */
const createAdminDivConfDefaultAPI = (props = {}) => {
  const { withCredentials, xsrfHeaderName, xsrfCookieName, headers } = props;

  const axiosInstance = axios.create({
    baseURL: ADMIN_DIV_CONF_BASE_URL,
    ...configureAxiosProperty({
      withCredentials,
      xsrfHeaderName,
      xsrfCookieName,
      headers,
    }),
  });

  requestInterceptors({ axiosInstance });
  responseInterceptors({ axiosInstance });

  return axiosInstance;
};

const adminDivConfDefaultAPI = createAdminDivConfDefaultAPI();

export default adminDivConfDefaultAPI;
